/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsOfUseRouteImport } from './routes/terms-of-use'
import { Route as PersonalDataRouteImport } from './routes/personal-data'
import { Route as LegalNoticesRouteImport } from './routes/legal-notices'
import { Route as CookiePreferencesRouteImport } from './routes/cookie-preferences'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as CleverscoreRouteImport } from './routes/cleverscore'
import { Route as AiUsageRouteImport } from './routes/ai-usage'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ConsultantsIndexRouteImport } from './routes/consultants/index'
import { Route as BackofficeIndexRouteImport } from './routes/backoffice/index'
import { Route as ConsultantsConsultantIdRouteImport } from './routes/consultants/$consultantId'

const TermsOfUseRoute = TermsOfUseRouteImport.update({
  id: '/terms-of-use',
  path: '/terms-of-use',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalDataRoute = PersonalDataRouteImport.update({
  id: '/personal-data',
  path: '/personal-data',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalNoticesRoute = LegalNoticesRouteImport.update({
  id: '/legal-notices',
  path: '/legal-notices',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiePreferencesRoute = CookiePreferencesRouteImport.update({
  id: '/cookie-preferences',
  path: '/cookie-preferences',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactUsRoute = ContactUsRouteImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => rootRouteImport,
} as any)
const CleverscoreRoute = CleverscoreRouteImport.update({
  id: '/cleverscore',
  path: '/cleverscore',
  getParentRoute: () => rootRouteImport,
} as any)
const AiUsageRoute = AiUsageRouteImport.update({
  id: '/ai-usage',
  path: '/ai-usage',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsultantsIndexRoute = ConsultantsIndexRouteImport.update({
  id: '/consultants/',
  path: '/consultants/',
  getParentRoute: () => rootRouteImport,
} as any)
const BackofficeIndexRoute = BackofficeIndexRouteImport.update({
  id: '/backoffice/',
  path: '/backoffice/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsultantsConsultantIdRoute = ConsultantsConsultantIdRouteImport.update({
  id: '/consultants/$consultantId',
  path: '/consultants/$consultantId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ai-usage': typeof AiUsageRoute
  '/cleverscore': typeof CleverscoreRoute
  '/contact-us': typeof ContactUsRoute
  '/cookie-preferences': typeof CookiePreferencesRoute
  '/legal-notices': typeof LegalNoticesRoute
  '/personal-data': typeof PersonalDataRoute
  '/terms-of-use': typeof TermsOfUseRoute
  '/consultants/$consultantId': typeof ConsultantsConsultantIdRoute
  '/backoffice': typeof BackofficeIndexRoute
  '/consultants': typeof ConsultantsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ai-usage': typeof AiUsageRoute
  '/cleverscore': typeof CleverscoreRoute
  '/contact-us': typeof ContactUsRoute
  '/cookie-preferences': typeof CookiePreferencesRoute
  '/legal-notices': typeof LegalNoticesRoute
  '/personal-data': typeof PersonalDataRoute
  '/terms-of-use': typeof TermsOfUseRoute
  '/consultants/$consultantId': typeof ConsultantsConsultantIdRoute
  '/backoffice': typeof BackofficeIndexRoute
  '/consultants': typeof ConsultantsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ai-usage': typeof AiUsageRoute
  '/cleverscore': typeof CleverscoreRoute
  '/contact-us': typeof ContactUsRoute
  '/cookie-preferences': typeof CookiePreferencesRoute
  '/legal-notices': typeof LegalNoticesRoute
  '/personal-data': typeof PersonalDataRoute
  '/terms-of-use': typeof TermsOfUseRoute
  '/consultants/$consultantId': typeof ConsultantsConsultantIdRoute
  '/backoffice/': typeof BackofficeIndexRoute
  '/consultants/': typeof ConsultantsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ai-usage'
    | '/cleverscore'
    | '/contact-us'
    | '/cookie-preferences'
    | '/legal-notices'
    | '/personal-data'
    | '/terms-of-use'
    | '/consultants/$consultantId'
    | '/backoffice'
    | '/consultants'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ai-usage'
    | '/cleverscore'
    | '/contact-us'
    | '/cookie-preferences'
    | '/legal-notices'
    | '/personal-data'
    | '/terms-of-use'
    | '/consultants/$consultantId'
    | '/backoffice'
    | '/consultants'
  id:
    | '__root__'
    | '/'
    | '/ai-usage'
    | '/cleverscore'
    | '/contact-us'
    | '/cookie-preferences'
    | '/legal-notices'
    | '/personal-data'
    | '/terms-of-use'
    | '/consultants/$consultantId'
    | '/backoffice/'
    | '/consultants/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AiUsageRoute: typeof AiUsageRoute
  CleverscoreRoute: typeof CleverscoreRoute
  ContactUsRoute: typeof ContactUsRoute
  CookiePreferencesRoute: typeof CookiePreferencesRoute
  LegalNoticesRoute: typeof LegalNoticesRoute
  PersonalDataRoute: typeof PersonalDataRoute
  TermsOfUseRoute: typeof TermsOfUseRoute
  ConsultantsConsultantIdRoute: typeof ConsultantsConsultantIdRoute
  BackofficeIndexRoute: typeof BackofficeIndexRoute
  ConsultantsIndexRoute: typeof ConsultantsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms-of-use': {
      id: '/terms-of-use'
      path: '/terms-of-use'
      fullPath: '/terms-of-use'
      preLoaderRoute: typeof TermsOfUseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personal-data': {
      id: '/personal-data'
      path: '/personal-data'
      fullPath: '/personal-data'
      preLoaderRoute: typeof PersonalDataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal-notices': {
      id: '/legal-notices'
      path: '/legal-notices'
      fullPath: '/legal-notices'
      preLoaderRoute: typeof LegalNoticesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookie-preferences': {
      id: '/cookie-preferences'
      path: '/cookie-preferences'
      fullPath: '/cookie-preferences'
      preLoaderRoute: typeof CookiePreferencesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact-us': {
      id: '/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof ContactUsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cleverscore': {
      id: '/cleverscore'
      path: '/cleverscore'
      fullPath: '/cleverscore'
      preLoaderRoute: typeof CleverscoreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-usage': {
      id: '/ai-usage'
      path: '/ai-usage'
      fullPath: '/ai-usage'
      preLoaderRoute: typeof AiUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consultants/': {
      id: '/consultants/'
      path: '/consultants'
      fullPath: '/consultants'
      preLoaderRoute: typeof ConsultantsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backoffice/': {
      id: '/backoffice/'
      path: '/backoffice'
      fullPath: '/backoffice'
      preLoaderRoute: typeof BackofficeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consultants/$consultantId': {
      id: '/consultants/$consultantId'
      path: '/consultants/$consultantId'
      fullPath: '/consultants/$consultantId'
      preLoaderRoute: typeof ConsultantsConsultantIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AiUsageRoute: AiUsageRoute,
  CleverscoreRoute: CleverscoreRoute,
  ContactUsRoute: ContactUsRoute,
  CookiePreferencesRoute: CookiePreferencesRoute,
  LegalNoticesRoute: LegalNoticesRoute,
  PersonalDataRoute: PersonalDataRoute,
  TermsOfUseRoute: TermsOfUseRoute,
  ConsultantsConsultantIdRoute: ConsultantsConsultantIdRoute,
  BackofficeIndexRoute: BackofficeIndexRoute,
  ConsultantsIndexRoute: ConsultantsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
